import { useCallback, useState } from "react";

const read = (key) => {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
};

/**
 * A true/false the viewer set, kept in this browser — for per-viewer
 * conveniences like a folded panel. Storage can be blocked (private window,
 * cleared site data); the flag then still works for this visit, starting false.
 *
 * @param {string} key - localStorage key
 * @returns {[boolean, () => void]} the flag, and a toggle
 */
const useStoredFlag = (key) => {
  const [flag, setFlag] = useState(() => read(key));

  const toggle = useCallback(() => {
    setFlag((prev) => {
      try {
        window.localStorage.setItem(key, prev ? "0" : "1");
      } catch {
        // Blocked storage: the toggle still works for this visit.
      }
      return !prev;
    });
  }, [key]);

  return [flag, toggle];
};

export default useStoredFlag;
